import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

import {
  computed,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseGridRow',
  props: {
  g: [Number, String],
  start: {
    type: Boolean,
    default: false,
  },
  center: {
    type: Boolean,
    default: false,
  },
  end: {
    type: Boolean,
    default: false,
  },
  verticalStart: {
    type: Boolean,
    default: false,
  },
  verticalCenter: {
    type: Boolean,
    default: false,
  },
  verticalEnd: {
    type: Boolean,
    default: false,
  },
  minHeight: {
    type: [Number, String],
    default: null,
  },
},
  setup(__props) {

const props = __props;



const classes = computed(() => {
  const classesArr = [];

  if ([0, 1, 2, 3, 4, 5].includes(Number(props.g))) {
    classesArr.push(`g-${props.g}`);
  }

  if (props.center) {
    classesArr.push('justify-content-center');
  } else if (props.end) {
    classesArr.push('justify-content-end');
  } else if (props.start) {
    classesArr.push('justify-content-start');
  }

  if (props.verticalCenter) {
    classesArr.push('align-items-center');
  } else if (props.verticalEnd) {
    classesArr.push('align-items-end');
  } else if (props.verticalStart) {
    classesArr.push('align-items-start');
  }

  return classesArr;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row", _unref(classes)])
  }, [
    (__props.minHeight)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "col-auto col-mh",
          style: _normalizeStyle(`height: ${ typeof __props.minHeight === 'number' ? (`${__props.minHeight}px`) : __props.minHeight }`)
        }, null, 4))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})